import { Text, type GridColDef } from '@shared/components';

import { RoleListMenu } from '../role-list-menu';

import { type AppRole } from './type';

export const columns: GridColDef<AppRole>[] = [
  {
    field: 'name',
    headerName: 'Role Name',
    flex: 1,
    renderCell: (params) => <Text sx={{ fontWeight: 600 }}>{params.row.name}</Text>,
  },
  { field: 'description', headerName: 'Description', flex: 2, sortable: false },
  {
    field: 'moreAction',
    width: 68,
    headerName: '',
    renderCell: (params) => {
      const { id } = params.row;
      return <RoleListMenu roleId={id} />;
    },
    sortable: false,
  },
];
